import Link from "next/link";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/
export default function Privacy() {
  return (
    <>
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/politica-de-privacidad`}
        title="Política de Privacidad"
        siteTitle="Movi Autos"
      />
      <div className="relative py-16 bg-white overflow-hidden">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div
            className="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          >
            <svg
              className="absolute top-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
              />
            </svg>
            <svg
              className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              className="absolute bottom-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="d3eb07ae-5182-43e6-857d-35c643af9034"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
              />
            </svg>
          </div>
        </div>
        <div className="relative px-4">
          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="block text-base text-center text-orange-600 font-semibold tracking-wide uppercase"></span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Política de Privacidad
              </span>
            </h1>
          </div>
          <div className="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            <h3>Introducción</h3>
            <p className="mt-8 text-xl text-gray-500 leading-8">
              Movi es un sitio web para compra y venta de autos, con un dominio
              de moviautos.com. En Movi, valoramos la privacidad de nuestros
              usuarios y comprendemos la importancia de proteger su información
              personal. Esta política de privacidad describe cómo recopilamos,
              utilizamos, compartimos y protegemos la información de nuestros
              usuarios y cómo esta información se relaciona con el uso de
              nuestro sitio web.
            </p>
            {/* <ul role="list">
            <li>Quis elit egestas venenatis mattis dignissim.</li>
            <li>
              Cras cras lobortis vitae vivamus ultricies facilisis tempus.
            </li>
            <li>Orci in sit morbi dignissim metus diam arcu pretium.</li>
          </ul> */}
            <h3>Recopilación de información</h3>
            <p>
              Recopilamos información de nuestros usuarios cuando se registran
              para vender un auto o cuando contactan a un vendedor. La
              información que podemos recopilar incluye, entre otras, el nombre,
              la dirección de correo electrónico, el número de teléfono y
              cualquier otra información que el usuario elija proporcionar.
            </p>
            <h3>Uso de la información recopilada</h3>
            <p>
              Utilizamos la información recopilada para proporcionar una
              experiencia más personalizada y eficiente para nuestros usuarios.
              También podemos utilizar esta información para responder a
              preguntas y resolver cualquier problema relacionado con el uso de
              nuestro sitio web.
            </p>
            <h3>Compartir información</h3>
            <p>
              Tomamos medidas de seguridad para proteger la información personal
              de nuestros usuarios contra el acceso no autorizado, la
              alteración, la divulgación o la destrucción. Sin embargo, ninguna
              transmisión de información a través de Internet es 100% segura y
              no podemos garantizar la seguridad de la información que nos
              envía.
            </p>
            <h3>Seguridad de la información</h3>
            <p>
              Tomamos medidas de seguridad para proteger la información personal
              de nuestros usuarios contra el acceso no autorizado, la
              alteración, la divulgación o la destrucción. Sin embargo, ninguna
              transmisión de información a través de Internet es 100% segura y
              no podemos garantizar la seguridad de la información que nos
              envía.
            </p>
            <h3>Cambios a esta política de privacidad</h3>
            <p>
              Podemos actualizar esta política de privacidad periódicamente para
              reflejar cambios en nuestro sitio web o en las prácticas de
              privacidad. Le informaremos de cualquier cambio significativo en
              la forma en que utilizamos su información personal mediante un
              aviso en nuestro sitio web.
            </p>
            <h3>Contacto</h3>
            <p>
              Si tiene preguntas sobre esta política de privacidad o sobre el
              uso de su información personal, póngase en contacto con nosotros a
              través de nuestro correo electrónico{" "}
              <a href="mailto:contacto@moviautos.com">contacto@moviautos.com</a>{" "}
              o número de teléfono proporcionados en nuestro sitio web.
            </p>
            <p>
              Consultar los{" "}
              <Link href="privacy">Términos y condiciones de uso</Link>.
            </p>
            {/* <blockquote>
            <p>
              Sagittis scelerisque nulla cursus in enim consectetur quam. Dictum
              urna sed consectetur neque tristique pellentesque. Blandit amet,
              sed aenean erat arcu morbi.
            </p>
          </blockquote>
          <p>
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
            enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
            praesent donec est. Odio penatibus risus viverra tellus varius sit
            neque erat velit.
          </p> */}
            {/* <figure>
            <img
              className="w-full rounded-lg"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&w=1310&h=873&q=80&facepad=3"
              alt=""
              width={1310}
              height={873}
            />
            <figcaption>
              Sagittis scelerisque nulla cursus in enim consectetur quam.
            </figcaption>
          </figure>
          <h2>Everything you need to get up and running</h2>
          <p>
            Purus morbi dignissim senectus mattis <a href="#">adipiscing</a>.
            Amet, massa quam varius orci dapibus volutpat cras. In amet eu
            ridiculus leo sodales cursus tristique. Tincidunt sed tempus ut
            viverra ridiculus non molestie. Gravida quis fringilla amet eget dui
            tempor dignissim. Facilisis auctor venenatis varius nunc, congue
            erat ac. Cras fermentum convallis quam.
          </p>
          <p>
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
            enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
            praesent donec est. Odio penatibus risus viverra tellus varius sit
            neque erat velit.
          </p> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

// Privacy.getLayout = function getLayout(page) {
//   return <Layout>{page}</Layout>;
// };
